// src/pages/ZaehlerEditor.jsx
// Zaehler an der Station (Anna-Lena 08.10.2026, Migration 76): Bezeichnung (Name),
// Zaehlernummer und Wandlerverhaeltnis. Mehrere Zaehler moeglich.
// Gespeichert als Liste in station_konfiguration.zaehler - im Buero-Formular
// (Reiter Wandler) und im Protokoll (Kapitel "Wandler / Zähler").
import { C, Field, TextInput, Row, ComboInput } from './formui';
import { t } from '../lib/sprache';

function neueId() {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0;
    return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
  });
}

// Vorschlaege fuers Wandlerverhaeltnis: die Uebersetzungen der erfassten
// Stromwandler plus die gaengigen Werte.
const UEBLICH = ['100/5 A', '150/5 A', '200/5 A', '250/5 A', '300/5 A', '400/5 A', '500/5 A', '600/5 A', '800/5 A', '1000/5 A', '1500/5 A', '2000/5 A'];
export function wandlerVorschlaege(wandler) {
  const aus = (wandler || []).filter(w => (w.wandler_typ || 'strom') === 'strom' && w.active !== false)
    .map(w => String(w.bemessunguebersetzung || '').trim()).filter(Boolean);
  return [...new Set([...aus, ...UEBLICH])];
}

export function zaehlerListe(wert) {
  return Array.isArray(wert) ? wert : [];
}

export default function ZaehlerEditor({ items, onChange, wandler, kompakt = false }) {
  const liste = zaehlerListe(items);
  const vorschlaege = wandlerVorschlaege(wandler);
  const update = (i, k, v) => onChange(liste.map((z, idx) => (idx === i ? { ...z, [k]: v } : z)));
  const add = () => onChange([...liste, { id: neueId(), bezeichnung: '', zaehlernummer: '', wandlerverhaeltnis: '' }]);
  const remove = (i) => {
    const z = liste[i];
    const leer = !z.bezeichnung && !z.zaehlernummer && !z.wandlerverhaeltnis;
    if (!leer && !window.confirm(t('Zähler {nr} wirklich entfernen?', { nr: i + 1 }))) return;
    onChange(liste.filter((_, idx) => idx !== i));
  };
  return (
    <>
      {liste.length === 0 && (
        <div style={{ fontSize: 15, color: C.gray500, fontStyle: 'italic', marginBottom: 10 }}>
          {t('Noch kein Zähler erfasst.')}
        </div>
      )}
      {liste.map((z, i) => (
        <div key={z.id || i} style={{ background: kompakt ? C.white : C.gray100, borderRadius: 9, padding: 12,
                                      marginBottom: 10, border: kompakt ? '1px solid ' + C.gray200 : 'none' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <div style={{ fontWeight: 800, color: C.navy, fontSize: 15 }}>
              {z.bezeichnung ? z.bezeichnung : t('Zähler {nr}', { nr: i + 1 })}
            </div>
            <button type='button' onClick={() => remove(i)}
              style={{ minHeight: 40, padding: '7px 13px', borderRadius: 7, border: '1.5px solid ' + C.gray200,
                       background: C.white, color: C.gray700, fontSize: 14, fontWeight: 600,
                       cursor: 'pointer', fontFamily: 'inherit' }}>
              {t('entfernen')}
            </button>
          </div>
          <Row columns={3}>
            <Field label={t('Zählerbezeichnung (Name)')} hint={t('z. B. Hauptzähler, Allgemeinstrom')}>
              <TextInput value={z.bezeichnung} onChange={v => update(i, 'bezeichnung', v)}/>
            </Field>
            <Field label={t('Zählernummer')}>
              <TextInput value={z.zaehlernummer} onChange={v => update(i, 'zaehlernummer', v)}/>
            </Field>
            <Field label={t('Wandlerverhältnis')} hint={t('z. B. 200/5 A')}>
              <ComboInput value={z.wandlerverhaeltnis} onChange={v => update(i, 'wandlerverhaeltnis', v)} options={vorschlaege} placeholder='200/5 A'/>
            </Field>
          </Row>
        </div>
      ))}
      <button type='button' onClick={add}
        style={{ width: '100%', minHeight: 48, padding: '11px 16px', borderRadius: 9,
                 border: '2px dashed ' + C.gray300, background: C.white, color: C.navy,
                 fontWeight: 700, fontSize: 15, cursor: 'pointer', fontFamily: 'inherit' }}>
        {t('+ Zähler')}
      </button>
    </>
  );
}
